import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';

import {ControlGroupViewStore, FormViewStore} from './viewstore';
import {ControlGroupContentModel, FormContentModel} from './contentmodel';


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class ControlGroupComponent extends BaseComponent {

    static get ViewStore() {
        return ControlGroupViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form,
            lastCm,
            viewBreadcrumbs,
            insideEditor
            /*inputStore: {
                getInput,
                setInput,
                isDirty,
                isLoading,
                revert
            }*/
        } = this.props;

        const {
            label,
            css,
            controls
        } = contentModel; // this contentModel's properties

        const {
            invalid,
            save
        } = this.viewStore; // this component's viewStore.  Will have actions and UI properties

        var elements = [];
        for(var i = 0; i < controls.length; ++i) {
            var props = {
              currentView: {contentModel: contentModel},
              options: {contentModel: controls[i]},
              contentModel: controls[i],
              lastCm: lastCm,
              viewBreadcrumbs: viewBreadcrumbs,
              insideEditor: insideEditor,
              form: form,
              key: i,
            };
            elements.push(
                React.createElement(controls[i].Component, props)
            );
        }

        return (
            <div className={"control-group " + css}>
                <div className="control-group-title" dangerouslySetInnerHTML={{__html:label}}></div>
                {elements}
            </div>
        )
    }
}


//@editable // this makes the view editable via authoring tool via data-editable
@observer // mobx manages this view
//@autoclass // this automatically gives consistent `className`s to components using module and component names
export class FormComponent extends BaseComponent {

    static get ViewStore() {
        return FormViewStore;
    }

    componentDidMount() {
        this.viewStore.createVariables();
        this.viewStore.startAutoUpdate();
    }
    componentWillUnmount() {
        this.viewStore.stopAutoUpdate();
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            lastCm,
            viewBreadcrumbs,
            insideEditor
            /*inputStore: {
                getInput,
                setInput,
                isDirty,
                isLoading,
                revert
            }*/
        } = this.props;

        const {
            title,
            css,
            controls
        } = contentModel; // this contentModel's properties

        const {
            invalid,
            save
        } = this.viewStore; // this component's viewStore.  Will have actions and UI properties

        var elements = [];
        for(var i = 0; i < controls.length; ++i) {
            var props = {
              currentView: {contentModel: contentModel},
              options: {contentModel: controls[i]},
              contentModel: controls[i],
              lastCm: lastCm,
              viewBreadcrumbs: viewBreadcrumbs,
              insideEditor: insideEditor,
              form: this.viewStore,
              key: i,
            };
            elements.push(
                React.createElement(controls[i].Component, props)
            );
        }

        return (
            <div className={"form " + css}>
                {elements}
            </div>
        )
    }
}
export default FormComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/forms/component.js